function prettyDecimal(number, precision) {
    const _number = parseFloat(number);
    const _precision = _number % 1 === 0 ? 0 : parseFloat(precision) || 1;
    return _number.toFixed(_precision);
}

export default () => prettyDecimal;



// WEBPACK FOOTER //
// ./src/js/components/common/prettydecimal/index.js